// constants.js
export const KONSTANTA1 = 'hodnota1';
export const KONSTANTA2 = 'hodnota2';
// další konstanty
